import type { FunctionComponent } from 'react';
import { usePropertyPageQuery } from '../../graphql/usePropertyPageQuery';
import { PropertyValuationBrick } from './PropertyValuationBrick';

export const PropertyValuationBrickWithDataV2: FunctionComponent = () => {
  const data = usePropertyPageQuery()?.data.propertyPageBySlugV3;

  if (!data?.valueEstimatesV2) return null;

  const { title, estimates, subtitle, caption, hideConfidenceLabel, alert } = data.valueEstimatesV2;

  if (!estimates) return null;

  return (
    <PropertyValuationBrick
      title={title}
      subtitle={subtitle}
      estimates={estimates}
      caption={caption}
      hideConfidenceLabel={hideConfidenceLabel ?? false}
      alert={alert}
    />
  );
};
